import { render, staticRenderFns } from "./oilCardDetail.vue?vue&type=template&id=0359b198&scoped=true&"
import script from "./oilCardDetail.vue?vue&type=script&lang=js&"
export * from "./oilCardDetail.vue?vue&type=script&lang=js&"
import style0 from "./oilCardDetail.vue?vue&type=style&index=0&id=0359b198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0359b198",
  null
  
)

export default component.exports